import { Typography } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import { formatNumber } from "accounting"
import classnames from "classnames"
import update from "immutability-helper"
import { subscribe, unsubscribe } from "pubsub-js"
import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { ADMIN_EVENT } from "types/pubsub"
import styles from "./styles"

let highBidSub
let removeBidSub
let addDonationSub
let handRemoveSub
let drawRaffleSub
let fixedPurchaseSub
let rafflePurchaseSub
class Shoutout extends Component {
  componentDidMount() {
    this.props.data.settings.events.forEach(event => {
      if (event === "bid_earnings") {
        // prevent double subscribing
        if (
          !this.state.subscriptions.highBid &&
          !this.state.subscriptions.removeBid
        ) {
          highBidSub = subscribe(`${ADMIN_EVENT}::highBid`, this.handleHighBid)
          removeBidSub = subscribe(
            `${ADMIN_EVENT}::removeBid`,
            this.handleHighBid
          )
          this.setState(
            update(this.state, {
              subscriptions: {
                highBid: {
                  $set: true
                },
                removeBid: {
                  $set: true
                }
              }
            })
          )
        }
      }

      if (event === "donation_pledges") {
        // prevent double subscribing
        if (
          !this.state.subscriptions.addDonation &&
          !this.state.subscriptions.removePledge
        ) {
          addDonationSub = subscribe(
            `${ADMIN_EVENT}::addDonation`,
            this.handleAddDonation
          )
          handRemoveSub = subscribe(
            `${ADMIN_EVENT}::removePledge`,
            this.handleRemovePledge
          )
          this.setState(
            update(this.state, {
              subscriptions: {
                addDonation: {
                  $set: true
                },
                removePledge: {
                  $set: true
                }
              }
            })
          )
        }
      }

      if (event === "raffle_winners") {
        // prevent double subscribing
        if (!this.state.subscriptions.drawRaffle) {
          drawRaffleSub = subscribe(
            `${ADMIN_EVENT}::drawRaffle`,
            this.handleRaffleWinner
          )
          this.setState(
            update(this.state, {
              subscriptions: {
                drawRaffle: {
                  $set: true
                }
              }
            })
          )
        }
      }

      if (event === "fixed_purchase_earnings") {
        // prevent double subscribing
        if (!this.state.subscriptions.fixedPurchase) {
          fixedPurchaseSub = subscribe(
            `${ADMIN_EVENT}::fixedPurchase`,
            this.handleFixedPurchase
          )
          this.setState(
            update(this.state, {
              subscriptions: {
                fixedPurchase: {
                  $set: true
                }
              }
            })
          )
        }
      }

      if (event === "raffle_purchase_earnings") {
        // prevent double subscribing
        if (!this.state.subscriptions.rafflePurchase) {
          rafflePurchaseSub = subscribe(
            `${ADMIN_EVENT}::rafflePurchase`,
            this.handleRafflePurchase
          )
          this.setState(
            update(this.state, {
              subscriptions: {
                rafflePurchase: {
                  $set: true
                }
              }
            })
          )
        }
      }
    })
  }
  componentWillUnmount() {
    unsubscribe(highBidSub)
    unsubscribe(removeBidSub)
    unsubscribe(addDonationSub)
    unsubscribe(handRemoveSub)
    unsubscribe(fixedPurchaseSub)
    unsubscribe(rafflePurchaseSub)
    unsubscribe(drawRaffleSub)
  }
  state = {
    pastShoutouts: [],
    currentData: {
      number: 250,
      user: {
        first_name: "Jordan",
        last_name: "Riser",
        full_name: "Jordan Riser",
        paddle_number: 123
      },
      type: "donation"
    },
    subscriptions: {},
    shoutoutList: [],
    running: false
  }
  handleAddDonation = (msg, data) => {
    let shouldHandleDonation = false
    if (this.state.pastShoutouts.length === 0) {
      shouldHandleDonation = true
    } else {
      if (
        !this.state.pastShoutouts
          .filter(shoutout => shoutout.type === "donation")
          .find(donation => donation.id === data.donation_id)
      ) {
        shouldHandleDonation = true
      }
    }
    if (shouldHandleDonation) {
      this.showNewShoutout({
        number: parseInt(data.donation_amt, 10),
        user: {
          full_name: data.user_name,
          first_name: data.first_name,
          last_name: data.last_name,
          paddle_number: data.paddle_number
        },
        id: data.donation_id,
        type: "donation"
      })
    }
  }
  handleHighBid = (msg, data) => {
    this.showNewShoutout({
      number: data.current_high_bid,
      user: {
        full_name: data.full_name,
        first_name: data.first_name,
        last_name: data.last_name,
        paddle_number: data.paddle_number
      },
      type: "bid"
    })
  }
  handleRaffleWinner = (msg, data) => {
    this.showNewShoutout({
      number: 0,
      user: {
        full_name: data.full_name,
        first_name: data.first_name,
        last_name: data.last_name,
        paddle_number: data.paddle_number
      },
      type: "raffle"
    })
  }
  showNewShoutout = data => {

    // this.setState({
    //   showContent: false
    // })

    this.setState(
      update(this.state, {
        shoutoutList: {
          $push: [data]
        }
      }))

    if (this.state.shoutoutList.length > 0 && !this.state.running) {
      this.setState(
        update(this.state, {
          running: {
            $set: true
          }
        }))
      this.animate()
    }


  }

  animate = () => {
    const localArr = [...this.state.shoutoutList]
    this.setState(
      update(this.state, {
        shoutoutList: {
          $set: []
        }
      })
    )
    localArr.map((x, i) => {
      const time = (i + 1) * 5000
      setTimeout(() => {
        // show shoutout
        this.setState(
          update(this.state, {
            currentData: {
              $set: x
            },
          })
        )
        setTimeout(() => {
          this.setState({
            showContent: true
          })
        }, 50)

        // remove shoutout
        setTimeout(() => {
          this.setState({
            showContent: false
          })
        }, 3500)
        const lastInArr = localArr[localArr.length - 1] === x
        if (this.state.shoutoutList.length > 0 && lastInArr) {
          this.animate()
        } else if (this.state.shoutoutList.length === 0 && lastInArr) {
          this.setState(
            update(this.state, {
              running: {
                $set: false
              }
            }))
        } else {
          return
        }
      }, time)
    })
  }

  render() {
    const { classes, data } = this.props
    const currentCurrencySymbol = this.props.event.currencyObj.symbol || "$"
    return (
      <div className={classes.container}>
        {!data.settings.hide_amount && (
          <div
            className={classnames(classes.left, {
              [classes.leftIn]: this.state.showContent
            })}
          >
            <Typography className={classes.number}>
              {this.state.currentData.type === "raffle" && "Winner!"}
              {this.state.currentData.type !== "raffle" &&
                `${currentCurrencySymbol}${formatNumber(this.state.currentData.number)}`}
            </Typography>

          </div>
        )}
        <div
          className={classnames(classes.right, {
            [classes.rightIn]: this.state.showContent
          })}
          style={{
            alignItems: data.settings.hide_amount ? "center" : null
          }}
        >
          <div>
            {this.state.currentData.type === "donation" && (
              <Typography className={classes.thankYou}>
                Thank you for your donation!
              </Typography>
            )}
            {this.state.currentData.type === "bid" && (
              <Typography className={classes.thankYou}>
                Thank you for your bid
              </Typography>
            )}
            <Typography className={classes.name}>
              {data.settings.name_style === "anonymous" ? "Anonymous" : this.state.currentData.user[this.props.data.settings.name_style]}
            </Typography>
            {this.state.currentData.type === "raffle" && (
              <Typography className={classes.thankYou}>
                Congratulations!
              </Typography>
            )}
            {this.state.currentData.type === "fixed" && (
              <Typography className={classes.thankYou}>
                Congratulations!!
              </Typography>
            )}

            
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  connect(),
  withStyles(styles, { withTheme: true })
)(Shoutout)



// WEBPACK FOOTER //
// ./src/components/Spotlight/index.jsx